module.exports = __webpack_public_path__ + "img/192e359.png";